// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1Jfpv","content":"LayoutSettings_content__2i9v7"};